// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { createContext } from 'react';

export const DynamicOverlapContext = createContext<(overlapHeight: number) => void>(() => {});



// WEBPACK FOOTER //
// /local/p4clients/src/internal/context/dynamic-overlap-context.ts